import { SingletonList } from "../../../../utils/SingletonList";
import { VolumetricGI } from "./VolumetricGI";
export class VolumetricGIManager {
    constructor() {
        this._GIVolumes = new SingletonList();
        this._needUpdateAllRender = true;
    }
    removeVolumetricGI(renderer) {
        let shaderData = renderer._baseRenderNode.shaderData;
        shaderData.removeDefine(VolumetricGI.SHADERDEFINE_VOLUMETRICGI);
        renderer.lightProbe = null;
    }
    add(volume) {
        this._GIVolumes.add(volume);
        this._needUpdateAllRender = true;
    }
    remove(volume) {
        this._GIVolumes.remove(volume);
        this._needUpdateAllRender = true;
    }
    _updateRenderObject(renderer) {
        if (this._GIVolumes.length == 0) {
            this.removeVolumetricGI(renderer);
            return;
        }
        let renderBounds = renderer.bounds;
        let maxOverlap = 0, overlap = 0;
        let currentVolume;
        let volumes = this._GIVolumes.elements;
        for (let index = 0; index < this._GIVolumes.length; index++) {
            let volume = volumes[index];
            if (!currentVolume) {
                overlap = renderBounds.calculateBoundsintersection(volume.bounds);
                if (overlap < maxOverlap)
                    continue;
            }
            else {
                if (currentVolume.importance > volume.importance)
                    continue;
                overlap = renderBounds.calculateBoundsintersection(volume.bounds);
                if (overlap < maxOverlap && currentVolume.importance == volume.importance)
                    continue;
            }
            currentVolume = volume;
            maxOverlap = overlap;
        }
        if (currentVolume) {
            renderer.lightProbe = currentVolume;
        }
        else {
            this.removeVolumetricGI(renderer);
        }
    }
    handleMotionlist(motionObjects) {
        for (let index = 0; index < motionObjects.length; index++) {
            let render = motionObjects.elements[index];
            if (render._surportVolumetricGI) {
                this._updateRenderObject(render);
            }
        }
        this._needUpdateAllRender = false;
    }
    reCaculateAllRenderObjects(renders) {
        for (let index = 0; index < renders.length; index++) {
            let render = renders.elements[index];
            if (render._surportVolumetricGI) {
                this._updateRenderObject(render);
            }
        }
        this._needUpdateAllRender = false;
    }
    destroy() {
        let count = this._GIVolumes.length;
        for (var i = 0; i < count; i++) {
            this._GIVolumes.elements[i].destroy();
        }
    }
}
